import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/iconBG.png'


const _withScopeId = n => (_pushScopeId("data-v-1b461386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar_page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "go_home" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-home" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "/home" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "logo",
        src: _imports_0,
        style: {"width":"clamp(60%, 50%, 100px)","alignment":"center"},
        class: "p-mr-2"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "byhome" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-double-left" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "byclose" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-double-left" })
  ])
], -1))
const _hoisted_3 = { class: "list-menu" }
const _hoisted_4 = { class: "log_out" }
const _hoisted_5 = { class: "logoutButton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelMenu = _resolveComponent("PanelMenu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PanelMenu, {
        model: $setup.appMenus,
        class: "p-panelmenu"
      }, null, 8, ["model"]),
      ($props.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Đăng xuất",
            onClick: $setup.logout,
            icon: "pi pi-sign-out",
            iconPos: "right",
            class: "p-button-secondary"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!$props.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'login' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: "Đăng nhập",
                  icon: "pi pi-sign-in",
                  iconPos: "right"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}